import { teamsStore } from '../teamsStore';
import { createStoreDispatcher, type StoreDispatcher } from '../../commands/storeDispatcher';
import type { TeamCommand } from './teamCommands';

let dispatcher: StoreDispatcher<TeamCommand> | null = null;
let initialized = false;

export function initTeamDispatcher(): StoreDispatcher<TeamCommand> {
  if (initialized) return dispatcher!;
  initialized = true;
  dispatcher = createStoreDispatcher<TeamCommand>(teamsStore);
  return dispatcher;
}

export function getTeamDispatcher(): StoreDispatcher<TeamCommand> {
  if (!dispatcher) {
    throw new Error('Team dispatcher not initialized. Call initTeamDispatcher() first.');
  }
  return dispatcher;
}
